import { FeishuIcon } from '@/components/icons'
import { helpTopicUrl } from '@/lib/help-links'
import type { BlockConfig, BlockMeta } from '@/blocks/types'
import { AuthMode, IntegrationType } from '@/blocks/types'

export const FeishuBlock: BlockConfig = {
  type: 'feishu',
  name: 'Feishu',
  description: 'Read Feishu documents and send chat messages',
  longDescription:
    'Connect a Feishu self-built app to read authorized docx documents and send text messages to chats. Wiki node tokens must first be resolved to docx document IDs.',
  authMode: AuthMode.OAuth,
  category: 'tools',
  integrationType: IntegrationType.Productivity,
  bgColor: 'var(--integration-feishu)',
  icon: FeishuIcon,
  docsLink: helpTopicUrl('integrations'),
  subBlocks: [
    {
      id: 'operation',
      value: () => 'read_document',
      title: 'Operation',
      type: 'dropdown',
      options: [
        {
          id: 'read_document',
          label: 'Read Feishu document',
        },
        {
          id: 'send_message',
          label: 'Send Feishu message',
        },
      ],
    },
    {
      id: 'credential',
      title: 'Feishu account',
      type: 'oauth-input',
      credentialKind: 'service-account',
      serviceId: 'feishu',
      canonicalParamId: 'oauthCredential',
      mode: 'basic',
      required: true,
    },
    {
      id: 'manualCredential',
      title: 'Feishu account',
      type: 'short-input',
      canonicalParamId: 'oauthCredential',
      mode: 'advanced',
      placeholder: 'Enter credential ID',
      required: true,
    },
    {
      id: 'documentId',
      title: 'Document ID',
      type: 'short-input',
      placeholder: 'Enter the document ID',
      required: true,
      condition: {
        field: 'operation',
        value: 'read_document',
      },
    },
    {
      id: 'chatId',
      title: 'Chat ID',
      type: 'short-input',
      placeholder: 'oc_...',
      required: true,
      condition: {
        field: 'operation',
        value: 'send_message',
      },
    },
    {
      id: 'text',
      title: 'Message text',
      type: 'long-input',
      placeholder: 'Enter the message text',
      required: true,
      condition: {
        field: 'operation',
        value: 'send_message',
      },
    },
  ],
  tools: {
    access: ['feishu_read_document', 'feishu_send_message'],
    config: { tool: (p) => `feishu_${p.operation || 'read_document'}` },
  },
  inputs: {
    documentId: {
      type: 'string',
      description: 'Document ID',
    },
    chatId: {
      type: 'string',
      description: 'Chat ID',
    },
    text: {
      type: 'string',
      description: 'Message text',
    },
    oauthCredential: {
      type: 'string',
      description: 'Connected app credential ID',
    },
  },
  outputs: {
    content: {
      type: 'string',
      description: 'Document or table text',
    },
    messageId: {
      type: 'string',
      description: 'Provider message ID',
    },
  },
}
export const FeishuBlockMeta = {
  tags: ['messaging', 'knowledge-base'],
  templates: [],
} satisfies BlockMeta
